import { AccountCircle, Logout } from "@mui/icons-material";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { logOut, selectCurrentUser } from "features/auth/authSlice";
import React from "react";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const AnalyticsNavbar = () => {
  const navigate = useNavigate();
  const currentUser = useSelector(selectCurrentUser);
  const dispatch = useDispatch();
  const auth = useAuth();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = (e) => {
    e.preventDefault();
    handleMenuClose();

    localStorage.removeItem("authState");
    localStorage.removeItem("locationStore");
    localStorage.removeItem("districtName");
    localStorage.removeItem("locationList");
    localStorage.removeItem("locationDropdown");
    localStorage.removeItem("reduxState");

    dispatch(logOut());
    auth.removeUser();
    auth.signoutRedirect({ id_token_hint: auth.user.id_token });
  };

  return (
    <Box
      sx={{
        backgroundColor: "#fbfbfb",
        borderBottom: "1px solid #e5e7eb",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",

          alignItems: "center",
          px: { xs: 1, sm: 3 },
        }}
      >
        <Box sx={{ display: "flex", flex: 1, alignItems: "center" }}>
          <img
            src="/assets/img/LC-logo.png"
            alt="Logo"
            style={{
              height: isMobile ? "32px" : "40px",
              cursor: "pointer",
            }}
            onClick={() => navigate("/mis-dashboard")}
          />
        </Box>

        {!isMobile && (
          <Box
            sx={{
              display: "flex",
              flex: 2,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                textAlign: "center",
              }}
            >
              MIS Dashboard
            </Typography>{" "}
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flex: 1,
            justifyContent: "right",
            gap: 1,
          }}
        >
          <AccountCircle sx={{ color: "#0ea5e9" }} />
          <Typography
            variant="body2"
            sx={{ color: "#1e293b", fontWeight: 600 }}
          >
            {currentUser?.name || "User"}
          </Typography>

          <Button
            onClick={handleLogout}
            variant="outlined"
            color="primary"
            size="small"
            sx={{
              minWidth: "auto",
              p: 0.5,
              borderRadius: 1.5,
              "&:hover": {
                backgroundColor: "#f44336",
                color: "#fff",
                borderColor: "#f44336",
              },
            }}
          >
            <Logout fontSize="small" className="fs-6" />
          </Button>
          {/* <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              elevation: 4,
              sx: {
                borderRadius: 2,
                overflow: "hidden",
                width: 180,
                mt: 1,
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                p: 0,
              },
            }}
          >
            <Box sx={{ p: 0 }}>
              <MenuItem
                onClick={handleLogout}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  py: 1,
                  px: 1.5,
                  borderRadius: 1.5,
                  color: "#dc2626",
                  fontWeight: 600,
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#fee2e2",
                    color: "#b91c1c",
                    transform: "translateX(0px)",
                  },
                }}
              >
                <Typography fontWeight={600}>Logout</Typography>
                <Logout fontSize="small" />
              </MenuItem>
            </Box>
          </Menu> */}
        </Box>
      </Toolbar>
    </Box>
  );
};

export default AnalyticsNavbar;
